module.exports = __webpack_public_path__ + "static/media/logo.57d452e6.png";